import { SocialHead } from "@components/all-pages/SocialHead";
import { SolanaPage } from "@components/nav/SolanaPage";
import type { NextPage } from "next";
import { ResponsiveBreakpoint } from "@utils/StyleConstants";
import { Collections } from "@components/nft/Collections";
import { Trending } from "@components/nft/trending";

const Heading = () => {
  return (
    <div className="heading flex-center flex-column">
      <h1 className="p-0">Explore NFTs</h1>
      <h2 className="p-0 text-secondary fw-regular">
        From Solanart, Magic Eden, and OpenSea
      </h2>
      <style jsx>{`
        .heading {
          h1 {
            font-size: 4.4rem;
            margin: 7rem 0 1.75rem 0;
            line-height: 90%;

            @media (max-width: ${ResponsiveBreakpoint.medium}) {
              font-size: 2.4rem;
              margin: 5rem 0 0.8rem 0;
            }
          }

          h2 {
            font-size: var(--font-size-lg);
            margin: 0 0 3rem 0;
            line-height: 133%;

            @media (max-width: ${ResponsiveBreakpoint.medium}) {
              font-size: 0.875rem;
              margin: 0 0 3rem 0;
            }
          }
        }
      `}</style>
    </div>
  );
};

const Content = () => {
  return (
    <div className="glow">
      <Heading />
      <div className="mt-3 mb-4">
        <Collections title="Featured Collections" infinite={false} />
      </div>
      <Trending />

      <style jsx>{`
        .glow {
          position: relative;
          width: 100%;
        }
      `}</style>
    </div>
  );
};

const Nfts: NextPage = () => {
  return (
    <SolanaPage title="Explore NFTs">
      <SocialHead subtitle="Explore NFTs" canonicalPath="/nfts" />
      <Content />
    </SolanaPage>
  );
};

export default Nfts;
